import { useEffect, useState } from "react"
import { GenericFlightPathAssetsThumbnail } from "../generics/genericAssetsListThumbnails"
import { selectLiveVideoFlightById } from "features/entity-caching/flights/selectors"
import { VideoMetadata } from "@nova/slice-video"
import {
    useHasFetchedOriginalData,
    useVideoData,
} from "plugins/Video/controllers/hooks/useControllerEvents"

export function LiveVideoAssetsThumbnail({ id }: { id: string }) {
    const [metadata, isLoading] = useLiveVideoMetadata({ flightId: id })
    return (
        <GenericFlightPathAssetsThumbnail
            id={id}
            selectEntity={selectLiveVideoFlightById}
            getMetadata={async () => metadata}
            isLoading={isLoading}
        />
    )
}

function useLiveVideoMetadata({ flightId }: { flightId: string }) {
    const [metadata, setMetadata] = useState<VideoMetadata>([])
    const data = useVideoData({ flightId, options: { fetchDataImmediately: true } })
    const hasFetchedOriginalData = useHasFetchedOriginalData({ flightId })
    useEffect(() => {
        const filtered = data.filter(
            (e, i) => e.timestamp !== data?.[i - 1]?.timestamp && !!e.latitude && !!e.longitude
        )
        setMetadata(filtered.map((data) => [data.longitude, data.latitude, 0, 0, 0, 0, 0, 0]) || [])
    }, [data])
    return [metadata, !hasFetchedOriginalData] as const
}
